import { render } from "./UploadExcel.vue?vue&type=template&id=1a7050a6"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"
script.render = render

export default script